import { Panel } from 'component/Space/Panel'
import { observer } from 'mobx-react-lite'
import { Height } from 'page/ProfileScreen/Heights/Height'
import { opt } from 'store/opt'
import { store } from 'store/store'

export const Heights = observer(() => {
  const { heights_config } = store.profile.form.cfg
  const last = heights_config.length - 1

  return <Panel base={opt.tsum ? 80 : 60}>
    {heights_config.map((config, index) => (
      <Height key={config.height} value={config.height} plus={index === last} />
    ))}
  </Panel>
})
